import { SET_CIRCUITO, SET_PASO, SET_PASO_ANTERIOR } from "../ActionTypes";

export const setPaso = (paso) => (dispatch) => {
  dispatch({ type: SET_PASO, payload: paso });
};
export const setCircuito = (circuitoElegido) => (dispatch) => {
  dispatch({ type: SET_CIRCUITO, payload: circuitoElegido });
};

export const setPasoAnterior = (paso) => (dispatch) => {
  dispatch({ type: SET_PASO_ANTERIOR, payload: paso });
};
